import { Grid, InnerSection, InvestorProfileChip, LabelValue, Modal, Typography } from "src/lib"
import { IRecommendationDetailsModalProps } from "./types"
import { mapPerfilToProfile } from "src/lib/transformers/ClientsOverviewInfo"
import intl from "src/internationalization/intl"
import { useDrawerStore, useMessageStore } from "src/store"

const RecommendationDetailsModal = ({ recommendation, client, open, ...props }: IRecommendationDetailsModalProps) => {
    const setJsonContext = useMessageStore((s: any) => s.setJsonContext)
    const setActualContext = useMessageStore((s: any) => s.setActualContext)
    const openDrawer = useDrawerStore((s: any) => s.openDrawer)

    const contextLabel = intl('investmentDetails')

    const handleClickAIButton = () => {
        setJsonContext(recommendation)
        setActualContext(contextLabel)
        openDrawer()
    }

    if (!recommendation) {
        return null
    }

    return (
        <Modal
            {...props}
            onClickAIButton={handleClickAIButton}
            open={open}
            title={intl('investmentDetails')}
        >
            <Grid item xs={12}>
                <InnerSection title={intl('product')} text={recommendation.product || '-'} />
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection
                    title="Vol(12M)"
                    text={
                        recommendation.product_aa !== null && recommendation.product_aa !== undefined
                            ? recommendation.product_aa.toFixed(2)
                            : '-'
                    }
                />
                <InnerSection title={intl('liquidity')} text={recommendation.liquidity || '-'} />
                <InnerSection title={intl('category')} text={recommendation.category || '-'} />
                <InnerSection title={intl('type') || 'Tipo'} text={recommendation.type || '-'} />
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <LabelValue
                    label={intl('comission')}
                    value={recommendation.administration_fee || '-'}
                    valueColor="accentSuccess.main"
                />
                <InnerSection title={intl('suitability')}>
                    <Grid sx={{mt: 1}}>
                        {/* TODO: pegar o perfil do investimento */}
                        <InvestorProfileChip profile={mapPerfilToProfile("SOFISTICADO")} />
                    </Grid>
                    <Typography variant="caption">{`${intl('reference')}: BTG`}</Typography>
                </InnerSection>
            </Grid>
            <Grid sx={{mt: 2}}>
                <InnerSection title={intl('effectiveReturn')}>
                    <Grid container gap={2} sx={{ mt: 1 }}>
                        {recommendation.effective_return_to_month && (
                            <InnerSection title={intl('month')} text={recommendation.effective_return_to_month} />
                        )}
                        {recommendation.effective_return_to_12_months && (
                            <InnerSection title={intl('year')} text={recommendation.effective_return_to_12_months} />
                        )}
                        {recommendation.effective_return_to_24_months && (
                            <InnerSection title={intl('m24')} text={recommendation.effective_return_to_24_months} />
                        )}
                        {recommendation.effective_return_to_36_months && (
                            <InnerSection title={intl('m36')} text={recommendation.effective_return_to_36_months} />
                        )}
                    </Grid>
                </InnerSection>
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title={intl('cnpj')} text={recommendation.cnpj || '-'} />
                <InnerSection title={intl('assetManager')} text="-" />
                <InnerSection title={intl('public')} text={recommendation.public || '-'} />
                <InnerSection title={intl('minimalApplication')} text={recommendation.minimal_application || '-'} />
            </Grid>
            {/* TODO: adicionar o restante das informações */}
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title={intl('globalRate')} text="-" />
                <InnerSection title={intl('referenceRate')} text="-" />
                <InnerSection title={intl('benchmark')} text={recommendation.benchmark || '-'} />
            </Grid>
        </Modal>
    )
}

export { RecommendationDetailsModal }

